import { createReducer } from "@reduxjs/toolkit";
import type { CreationState } from "@redux/state/shared-types";
import { createExternalProviderBatchRequest, resetCreateExternalProviderBatchRequest } from "./create-external-provider-batch-request";

const initialState: CreationState = { justCreatedId: null, processing: "idle" };

export const createExternalProviderBatchRequestReducer = createReducer<CreationState>(initialState, builder => {
  builder.addCase(createExternalProviderBatchRequest.fulfilled, (state, { payload }) => {
    return {
      ...state,
      justCreatedId: payload,
      processing: "success",
    };
  });
  builder.addCase(createExternalProviderBatchRequest.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(createExternalProviderBatchRequest.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCreateExternalProviderBatchRequest, () => {
    return initialState;
  });
});
